import {
    CaseReducer,
    createSlice,
    CreateSliceOptions,
    PayloadAction,
    SliceCaseReducers,
    ValidateSliceCaseReducers,
} from "@reduxjs/toolkit";

// ! README: documentation/development/stackable_drawer_system.md

export interface IBaseDrawerState {
    drawerHistoryInstanceId: string;
    show: boolean;
    parentId?: string;
}

type StandardDrawerReducers<State extends IBaseDrawerState> = {
    rehydrateState: CaseReducer<State, PayloadAction<Partial<State>>>;
    resetState: CaseReducer<State>;
};

export function createDrawerSlice<
    State extends IBaseDrawerState,
    CR extends SliceCaseReducers<State>,
    Name extends string,
>({
    name,
    initialState,
    reducers,
    ...rest
}: Omit<CreateSliceOptions<State, CR & StandardDrawerReducers<State>>, "reducers"> & {
    name: Name;
    reducers: CR;
}) {
    const standardReducers: StandardDrawerReducers<State> = {
        rehydrateState: (state, action: PayloadAction<Partial<State>>) => {
            // For some reason also deconstructing the initial state prevents from closing the container log drawer after opening it up to create a new one
            // Object.assign(state, { ...initialState, ...action.payload, show: true });
            Object.assign(state, { ...action.payload, show: true });
        },
        resetState: () => {
            return { ...initialState } as State;
        },
    };

    const combinedReducers = {
        ...reducers,
        ...standardReducers,
    } as ValidateSliceCaseReducers<State, CR & StandardDrawerReducers<State>>;

    return createSlice({
        name,
        initialState,
        reducers: combinedReducers,
        ...rest,
    });
}
